<template>
<div class="chapter">
<div class="inner_page">
      ﻿

<title>LifeBeg-1</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<meta content="application/xhtml+xml; charset=utf-8" http-equiv="Content-Type"/>
<div>
<p class="bd-8" style="text-align:center;">Recent Doonesbury Books by G.B. Trudeau</p>
<p class="copyright-00" style="text-align:center">Read My Lips, Make My Day, Eat Quiche and Die!</p>
<p class="copyright-00" style="text-align:center">Give Those Nymphs Some Hooters!</p>
<p class="copyright-00" style="text-align:center">You’re Smokin’ Now, Mr. Butts!</p>
<p class="copyright-00" style="text-align:center">I’d Go With the Helmet, Ray</p>
<p class="copyright-00" style="text-align:center">Welcome to Club Scud!</p>
<p class="copyright-00" style="text-align:center">What Is It, Tink, Is Pan in Trouble?</p>
<p class="copyright-00" style="text-align:center">Quality Time on Highway 1</p>
<p class="copyright-00" style="text-align:center">Washed Out Bridges and Other Disasters</p>
<p class="copyright-00" style="text-align:center">In Search of Cigarette Holder Man</p>
<p class="copyright-00" style="text-align:center">Doonesbury Nation</p>
<p class="copyright-00" style="text-align:center">Virtual Doonesbury</p>
<p class="copyright-00" style="text-align:center">Planet Doonesbury</p>
<p class="copyright-00" style="text-align:center">Buck Wild Doonesbury</p>
<p class="copyright-00" style="text-align:center">Duke 2000: Whatever It Takes</p>
<p class="copyright-00" style="text-align:center">The Revolt of the English Majors </p>
<p class="bd-8" style="text-align:center;">Special Collections</p>
<p class="copyright-00" style="text-align:center">The Doonesbury Chronicles</p>
<p class="copyright-00" style="text-align:center">Doonesbury’s Greatest Hits</p>
<p class="copyright-00" style="text-align:center">The People’s Doonesbury</p>
<p class="copyright-00" style="text-align:center">Doonesbury Dossier: The Reagan Years</p>
<p class="copyright-00" style="text-align:center">Doonesbury Deluxe: Selected Glances Askance</p>
<p class="copyright-00" style="text-align:center">Recycled Doonesbury: Second Thoughts on a Gilded Age</p>
<p class="copyright-00" style="text-align:center">Action Figure!</p>
<p class="copyright-00" style="text-align:center">The Portable Doonesbury</p>
<p class="copyright-00" style="text-align:center">Flashbacks: Twenty-five Years of Doonesbury</p>
<p class="copyright-00" style="text-align:center">The Bundled Doonesbury</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pod03.vue?6ee746ce